import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BatteryPoolDialogState, BatteryPoolState } from './battery-pool.reducer';

export const getBatteryPoolState = createFeatureSelector<BatteryPoolState>('batteryPools');

export const getSelectedBatteryPoolId = createSelector(
  getBatteryPoolState,
  (state: BatteryPoolState) => state.selectedBatteryPoolId
);

export const getSelectedPool = createSelector(getBatteryPoolState, (state: BatteryPoolState) =>
  state.batteryPools.find(pool => pool.poolId === state.selectedBatteryPoolId)
);

export const getBatteryPools = createSelector(
  getBatteryPoolState,
  (state: BatteryPoolState) => state?.batteryPools || []
);

// Battery Pool Dialog selectors
export const getBatteryPoolDialogState = createSelector(getBatteryPoolState, (batteryPoolState: BatteryPoolState) => {
  return batteryPoolState.batteryPoolDialogState;
});

export const getDialogIsLoading = createSelector(
  getBatteryPoolDialogState,
  (batteryPoolDialogState: BatteryPoolDialogState) => {
    return batteryPoolDialogState.isLoading;
  }
);

export const getBatteryPoolConfig = createSelector(
  getBatteryPoolDialogState,
  (batteryPoolDialogState: BatteryPoolDialogState) => {
    return batteryPoolDialogState.batteryPoolConfig;
  }
);

export const getDialogMcInstances = createSelector(
  getBatteryPoolDialogState,
  (batteryPoolDialogState: BatteryPoolDialogState) => {
    return batteryPoolDialogState.mcInstances;
  }
);

export const getDialogMcInstanceGroups = createSelector(
  getBatteryPoolDialogState,
  (batteryPoolDialogState: BatteryPoolDialogState) => {
    return batteryPoolDialogState.mcInstanceGroups.filter(group => group.hasGroupAccess);
  }
);

export const getDialogAllMcInstanceGroups = createSelector(
  getBatteryPoolDialogState,
  (profileDialogState: BatteryPoolDialogState) => {
    return profileDialogState.mcInstanceGroups;
  }
);
